export default __webpack_public_path__ + "static/media/facebook.af630745.svg";